"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommonSettingsMenu = void 0;

var _constants = require("../../../../constants");

var _features = require("../../../../Shared/store/features");

var getCommonSettingsMenu = function getCommonSettingsMenu() {
  var settings = [{
    link: 'personal',
    label: 'Profile & Settings',
    featureFlag: null
  }, {
    link: 'templates',
    label: 'Templates',
    featureFlag: null
  }, {
    link: 'integrations',
    label: 'Integrations',
    featureFlag: null
  }, {
    link: 'email-notifications',
    label: 'Email Notifications',
    featureFlag: _features.Features.FLAGS.ASSIST
  }];

  if (_constants.SHOW_BILLING_MODULE) {
    settings.push({
      link: 'billing',
      label: 'Billing'
    });
  }

  return settings;
};

exports.getCommonSettingsMenu = getCommonSettingsMenu;